const keys = Object.keys;
export {
  keys
};
//# sourceMappingURL=keys.js.map
